import React, { useState, useEffect } from 'react';
import ModalOrderDetailMobile from '../components/ModalOrderDetailMobile';

const IP = "https://pepetoys-backend.mindnt.com.mx/api/";

const VentasMobile = ({ onMenuSelect }) => {
  const [sales, setSales] = useState([]);
  const [filteredSales, setFilteredSales] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showOrderDetail, setShowOrderDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSales(sales);
    } else {
      const filtered = sales.filter(sale =>
        sale.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        sale.customer_phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        sale.id?.toString().includes(searchTerm) ||
        sale.code_order?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSales(filtered);
    }
  }, [sales, searchTerm]);

  const fetchSales = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${IP}orders/get-all-sales`);
      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          setSales(result.data);
        }
      }
    } catch (error) {
      console.error('Error fetching sales:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSales();
  }, []);

  const handleViewOrderDetail = (order) => {
    setSelectedOrder(order);
    setShowOrderDetail(true);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX', {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  return (
    <div className="flex flex-col h-[100dvh] w-full bg-gray-100 overflow-hidden">
      {/* Mobile Header */}
      <header className="bg-white shadow-sm px-4 py-4 sticky top-0 z-10 flex flex-col space-y-3 border-b border-gray-200">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">Ventas Celular</h1>
          {/* Button to go back to desktop layout if needed */}
          <button 
            onClick={() => onMenuSelect && onMenuSelect('ventas')}
            className="text-gray-400 hover:text-gray-800 p-1"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="relative">
          <svg className="w-5 h-5 text-gray-400 absolute left-3 top-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Buscar cliente o código..."
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
            disabled={isLoading}
          />
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 overflow-y-auto p-4 space-y-4">
        {isLoading ? (
          <div className="flex justify-center items-center py-10">
            <div className="text-gray-500 font-medium">Cargando ventas...</div>
          </div>
        ) : filteredSales.length === 0 ? (
          <div className="flex justify-center items-center py-10">
            <div className="text-gray-500 font-medium">No hay ventas registradas</div>
          </div>
        ) : (
          filteredSales.map((sale) => (
            <div 
              key={sale.id} 
              className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 flex flex-col space-y-4 active:bg-gray-50 transition-colors"
              onClick={() => handleViewOrderDetail(sale)}
            >
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-bold text-gray-900 text-lg leading-tight mb-1">{sale.customer_name || 'Sin nombre'}</h3>
                  <p className="text-sm text-gray-500 flex items-center">
                    <svg className="w-4 h-4 mr-1 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    {sale.customer_phone}
                  </p>
                </div>
                <span className="font-bold text-green-600 text-lg">
                  ${sale.total_amount?.toFixed(2)}
                </span>
              </div>
              
              <div className="flex justify-between items-center text-sm text-gray-500 border-t border-gray-100 pt-3">
                <div className="flex flex-col">
                  <span>Ord: <span className="font-mono text-gray-800 bg-gray-100 px-1.5 py-0.5 rounded text-xs">{sale.code_order || sale.id}</span></span>
                  <span className="mt-1 text-xs">{formatDate(sale.sale_date)}</span>
                </div>
                <button
                  className="px-4 py-2 bg-blue-50 text-blue-600 font-bold rounded-lg"
                >
                  Ver
                </button>
              </div>
            </div>
          ))
        )}
      </main>

      {/* Order Detail Modal */}
      {showOrderDetail && (
        <ModalOrderDetailMobile
          isOpen={showOrderDetail}
          onClose={() => {
            setShowOrderDetail(false);
            setSelectedOrder(null);
          }}
          orderData={selectedOrder}
        />
      )}
    </div>
  );
};

export default VentasMobile;
